import React, { Component } from "react";
import config from "react-global-configuration";
import axios from "axios";
import $ from "jquery";
//import Select from 'react-select';
import "datatables.net";
import "datatables.net-responsive";
import "../assets/css/datatables/datatables.min.css";
import "../assets/css/react-confirm-alert/react-confirm-alert.css";
import "./css/ipos-navbar.css";
import { Link, Redirect } from "react-router-dom";
import "react-calendar/dist/Calendar.css";
import Dnarrow from "../assets/img/dropdown_arrow.png";
import Terminalicon from "../assets/img/terminal_icon.png";
import Green from "../assets/img/green.png";
import MobNavbar from "./js/BottomNav";
import { isMobile } from "react-device-detect";
import "./css/TotalEMI.css";
import TopNavbar from "ipos/js/ProfileTopbar";
import moment from "moment";
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';
import jwt_decode from "jwt-decode";
import { MenuItem, Nav, NavDropdown, NavItem } from "react-bootstrap";
import imgNobody from '../assets/img/faces/nobody_m.original.jpg';
import {connect}  from  "react-redux";

const override = css`
    position:absolute;
    display: inline-block;
    margin-left:40%;
    margin-top:200px;
    border-color: red;
    text-align: center;
`;

const reportstyle = {
  backgroundColor:"rgba(240, 247, 171, 0.60)",
  border: "1px solid #ccc",
  margin: "20px 0px",
  padding: "5px",
  // borderRadius: "5px",
};

const arrstyle = {
  width: "24px",
  marginLeft: "4px",
  transform: [{ rotate: "180deg" }],
};

class IposProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rotation: 0,
      showterdiv: null,
      userDetails: {},
      loader: true,
      showter:false,
      terminaldetails: [],
    };
    this.rotate = this.rotate.bind(this);
  }

  componentDidMount() {
    this.fetchLoginData();
    this.props.currentMenu("totalemi");
  }

  fetchLoginData = () => {
    const decoded = jwt_decode(localStorage.usertoken);
    let phoneno = decoded.phone;
    // let phoneno= "9902922671";
    this.setState({ loader: true })
    axios
      .post(config.get("API_URL") + "/users/totalemi-login", {
        mobileNumber: phoneno,
        password: phoneno,
        userType: "Merchant"
      })
      .then((response) => {
        if (response.data.responseCode == "00") {

          this.setState({
            userDetails: response.data.responseDetails.userDetails,
            shopName: response.data.responseDetails.userDetails.profile.shopName,
            shopAddress: response.data.responseDetails.userDetails.profile.shopAddress,
            terminaldetails: response.data.responseDetails.userDetails.profile.terminals,
            loader: false,
          })
          //  console.log(this.state.userDetails);
          //  console.log(this.state.userDetails.profile.shopName);
        }
        else {  alert("User data is not onboarded on sparcs"); }
      });
  }

  rotate(e) {
    let currterminal= parseInt(e.target.alt);

    this.setState({
      showterdiv:currterminal,
      showter:!this.state.showter,
    });

    let newRotation = this.state.rotation - 180;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    this.setState({
      rotation: newRotation,
    });
  }

 

  render() {
    const { rotation } = this.state;

    return (
      <>
        {isMobile && <TopNavbar trn={this.state.terminalNo} />}
        <div className="fixed-content">
          <div className="container-fluid ">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12">
                <div className="content">
                  <div className="card">
                    {this.state.loader === false ? <div className="row m-t-10">
                      <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 text-center">
                          <h4 style={{ fontSize: "120%", color: "#666666" }}>
                            Profile
                          </h4>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12  p-5"
                          style={{
                            textAlign: "-webkit-center",
                            background: 'linear-gradient(134.72deg, #F5B00A 0%, #FE6009 100%)',
                            marginBottom: '10px',
                          }}
                        >
                          <img
                            src={imgNobody }
                            className="profile text-center"
                            style={{ height: "100px", borderRadius: "50%" }}
                          />

                          <div className="col-md-12 col-xs-12 col-sm-12 col-lg-12 p-5 text-center">
                            <p style={{ color: "#fff", fontSize: "120%" }}>
                              {this.state.userDetails.name}
                            </p>
                            <p style={{ color: "#fff" }}> {this.state.shopName}  </p>


                          </div>
                        </div>
                        <div className=" col-lg-6 col-md-6 col-xs-12 col-sm-12 ">

                          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                            <div className="col-lg-2 col-md-3 col-xs-2 col-sm-3 p-0">
                              <p className="profile-head">Email : </p>
                            </div>
                            <div className="col-lg-9 col-md-9 col-xs-10 col-sm-9 p-0">
                              <p style={{ color: "#9A9A9A" }}>
                                {this.state.userDetails.email}
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 devider"></div>
                          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                            <div className=" col-lg-2 col-md-3 col-xs-2 col-sm-3  p-0">
                              <p className="profile-head">Mob : </p>
                            </div>
                            <div className=" col-lg-9 col-md-9 col-xs-10 col-sm-9  p-0">
                              <p style={{ float: "left", color: "#9A9A9A" }}>
                                +91   {this.state.userDetails.mobileNumber}
                              </p>{" "}
                              <span
                                style={{ color: "#14ce14", padding: "0px 10%" }}
                              >
                                verified
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 devider"></div>
                          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                            <div className="col-md-3 col-xs-5 col-sm-5 col-lg-3 p-0">
                              <p className="profile-head">Shop Address :</p>
                            </div>
                            <div className="col-md-9 col-xs-7 col-sm-7 col-lg-9 p-0">
                              <p
                                style={{
                                  float: "left",
                                  textTransform: "capitalize",
                                  color: "#9A9A9A",
                                  wordBreak: 'break-word',
                                }}
                              >
                                {this.state.shopAddress}
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 devider"></div>
                          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                            <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12 p-0">
                              <p className="profile-head"> My Terminals</p>
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 devider"></div>
                          {this.state.terminaldetails.map((val, key) => {
                            return (
                              <>
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                  <div className="col-md-3 col-xs-3 col-sm-3 col-lg-3 p-0">
                                    <p className="exp"> {val.utid} : </p>
                                  </div>
                                  <div className="col-md-7 col-xs-7 col-sm-7 col-lg-7 p-0">
                                    <p
                                      className="planexp"
                                      style={{ color: "#F47626", fontSize: "13px" }}
                                    >
                                      Plan Expiring on {moment(val.expiryDate).format("DD MMM YYYY")}
                                    </p>
                                  </div>

                                  <div
                                    className="col-md-2 col-xs-2 col-sm-2 col-lg-2"
                                    onClick={this.rotate.bind(this)}
                                  >
                                    <img
                                      src={Dnarrow}
                                      onClick={this.rotate.bind(this)}
                                      style={{
                                        transform: `rotate(${rotation}deg)`,
                                        width: "26px",
                                        marginTop: "-5px",
                                      }}
                                      alt={key}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 devider"></div>
                                {this.state.showterdiv==key && this.state.showter &&
                                  <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                    <div className="col-md-3 col-xs-3 col-sm-3 col-lg-3 p-0">
                                      <img
                                        src={Terminalicon}
                                        style={{ width: "60px" }}
                                      />
                                    </div>

                                    <div className="col-md-2 col-xs-2 col-sm-2 col-lg-2 p-0">
                                      <p style={{ fontWeight: '600', color: '#666666' }}>UTID. </p>
                                      <p style={{ fontWeight: '600', color: '#666666' }}>Serial No </p>
                                    </div>
                                    <div className="col-md-1 col-xs-1 col-sm-1 col-lg-1 p-0">
                                      <p>:</p>
                                      <p>:</p>
                                    </div>
                                    <div className="col-md-3 col-xs-4 col-sm-4 col-lg-4 p-0">
                                      <p style={{color:'#9A9A9A'}}> {val.utid}</p>
                                      <p style={{ wordBreak: 'break-word',color:'#9A9A9A'}}>{val.serialNumber}</p>
                                    </div>
                                    <div className="col-md-2 col-xs-2 col-sm-2 col-lg-2 p-0">
                                      <p
                                        style={{ color: "#18CB73", fontSize: "13px" }}
                                      >
                                        <img
                                          className="profile"
                                          src={Green}
                                          style={{ height: "10px", fontSize: "13px" }}
                                        />{" "}
                                  online
                                </p>
                                    </div>

                                    <div
                                      className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"
                                      style={{ borderTop: "1px solid darkgray" }}
                                    >

                                    </div>

                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                                      <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 text-center p-0">
                                        <div className="row" style={reportstyle}>
                                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                                            <span
                                              style={{
                                                fontSize: "15px",
                                                color: "#4A4A4A",
                                              }}
                                            >
                                              {moment(val.activatedDate).format("DD MMM YYYY")}
                                            </span>
                                            <span style={{display:'block',fontSize:'12px',color:'#9B9B9B'}}>Activated On</span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 p-0"></div>
                                      <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 text-center p-0">
                                        <div className="row" style={reportstyle}>
                                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                                            <span
                                              style={{
                                                fontSize: "15px",
                                                color: "#FA7626",
                                              }}
                                            >
                                              {moment(val.expiryDate).format("DD MMM YYYY")}
                                            </span>
                                            <span style={{display:'block',fontSize:'12px',color:'#9A9A9A'}}>Expires On</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </>
                            )
                          })
                          }


                          {isMobile && <Nav>
                            <NavItem href="/admin/logout/">
                              <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                <div className="text-center" style={{ background: 'lightgrey', borderRadius: '10px' }}>
                                  <h5 style={{ color: "red", padding: "10px", borderRadius: '10px',fontWeight:'600' }}>
                                    Log out
                              </h5>
                                </div>
                              </div>
                            </NavItem>
                          </Nav>
                          }
                        </div>

                      </div>

                    </div>
                      :
                      <BeatLoader
                        css={override}
                        sizeUnit={"px"}
                        size={15}
                        color={'#123abc'}
                        loading={this.state.loader}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(IposProfile);
